import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  fill(event) {
    const id = event.target.dataset.fillSourceId;
    this.inputTarget.value = document.querySelector(`#${id}`).textContent;
  }
}
